<img src="https://padelyard-om.com/assets/t1.png"
style="z-index: 0;position: absolute;
height: 100vh;image-orientation: contain, cover;width: fit-content;"
/> 

<div class="app-main flex-column flex-row-fluid h-full" id="kt_app_main" style="height: 100vh;">
  <div class="d-flex flex-column flex-column-fluid">


    <div class="
stepper stepper-pills stepper-column
d-flex
flex-column flex-xl-row flex-row-fluid
" id="kt_create_account_stepper">



      <div class="d-flex flex-row-fluid flex-center bg-body  border border-right-1 border-dashed"
        style="background: #fcfcfc !important;" >
    
        <form class="py-20 w-100 w-xl-700px px-9" noValidate id="kt_create_account_form"
              style="z-index: 50;
              background: #ffffffbd;">
          <div class="current" >
   
            <ng-container *ngIf="currentStep$.value === 1">

              <div style="direction: rtl;" class="stepper-item" [ngClass]="{
                current: currentStep$.value === 1,
                completed: currentStep$.value > 1
              }">
                      <!--begin::Wrapper-->
                      <div class="stepper-wrapper">
                        <!--begin::Icon-->
                        <div class="stepper-icon w-40px h-40px">
                          <i class="stepper-check fas fa-check"></i>
                          <span class="stepper-number">1</span>
                        </div>
                        <!--end::Icon-->
        
                        <!--begin::Label-->
                        <div class="stepper-label mx-4">
                          <h3 class="stepper-title">
                             التاريخ والوقت
                          </h3>
        
                          <div class="stepper-desc fw-semibold">
                            أختر التاريخ والوقت المناسب لك للحجز
                          </div>
                        </div>
                        <!--end::Label-->
                      </div>
                      <!--end::Wrapper-->
        
                      <!--begin::Line-->
                      <div class="stepper-line h-40px"></div>
                      <!--end::Line-->
                    </div>
        
              <app-step1 class="w-100" [updateParentModel]="updateAccount" [defaultValues]="account$.value"></app-step1>
            </ng-container>

            <ng-container *ngIf="currentStep$.value === 2">
              <div  style="direction: rtl;"  class="stepper-item" [ngClass]="{
                current: currentStep$.value === 2,
                completed: currentStep$.value > 2
              }">
                      <!--begin::Wrapper-->
                      <div class="stepper-wrapper">
                        <!--begin::Icon-->
                        <div class="stepper-icon w-40px h-40px">
                          <i class="stepper-check fas fa-check"></i>
                          <span class="stepper-number">2</span>
                        </div>
                        <!--end::Icon-->
        
                        <!--begin::Label-->
                        <div class="stepper-label mx-4">
                          <h3 class="stepper-title">
                            أختر الملعب المناسب
                          </h3>
                          <div class="stepper-desc fw-semibold">
                            أختر الملعب المتاح في الوقت والتاريخ المحدد
                          </div>
                        </div>
                        <!--end::Label-->
                      </div>
                      <!--end::Wrapper-->
        
                      <!--begin::Line-->
                      <div class="stepper-line h-40px"></div>
                      <!--end::Line-->
                    </div>
              <app-step2 class="w-100" [updateParentModel]="updateAccount"  [siblings]="siblings" [defaultValues]="account$.value"></app-step2>
            </ng-container>

            <ng-container  *ngIf="currentStep$.value === 3">

            <div style="direction: rtl;" class="stepper-item" [ngClass]="{
              current: currentStep$.value === 3,
              completed: currentStep$.value > 3
            }">
                    <!--begin::Wrapper-->
                    <div class="stepper-wrapper">
                      <!--begin::Icon-->
                      <div class="stepper-icon w-40px h-40px">
                        <i class="stepper-check fas fa-check"></i>
                        <span class="stepper-number">2</span>
                      </div>
                      <!--end::Icon-->
      
                      <!--begin::Label-->
                      <div class="stepper-label mx-4">
                        <h3 class="stepper-title">
                          أدخل بياناتك
                        </h3>
                        <div class="stepper-desc fw-semibold">
                          أدخل بياناتك لإكمال عملية الحجز
                        </div>
                      </div>
                      <!--end::Label-->
                    </div>
                    <!--end::Wrapper-->
      
                    <!--begin::Line-->
                    <div class="stepper-line h-40px"></div>
                    <!--end::Line-->
                  </div>
              <app-step3 class="w-100" [updateParentModel]="updateAccount" [defaultValues]="account$.value"></app-step3>
            </ng-container>

            <ng-container *ngIf="currentStep$.value === 4">


            <div style="direction: rtl;" class="stepper-item" [ngClass]="{
              current: currentStep$.value === 4,
              completed: currentStep$.value > 4
            }">
                    <!--begin::Wrapper-->
                    <div class="stepper-wrapper">
                      <!--begin::Icon-->
                      <div class="stepper-icon w-40px h-40px">
                        <i class="stepper-check fas fa-check"></i>
                        <span class="stepper-number">3</span>
                      </div>
                      <!--end::Icon-->
      
                      <!--begin::Label-->
                      <div class="stepper-label mx-4">
                        <h3 class="stepper-title">
                          طريقة الدفع
                        </h3>
                        <div class="stepper-desc fw-semibold">
                          أختر طريقة الدفع المناسبة لك
                        </div>
                      </div>
                      <!--end::Label-->
                    </div>
                    <!--end::Wrapper-->
      
                    <!--begin::Line-->
                    <div class="stepper-line h-40px"></div>
                    <!--end::Line-->
                  </div>
      
              <app-step4 class="w-100" [updateParentModel]="updateAccount" [defaultValues]="account$.value"></app-step4>


            </ng-container>
            <ng-container *ngIf="currentStep$.value === 5">
              <div style="direction: rtl;" class="stepper-item" [ngClass]="{ current: currentStep$.value === 5 }">
                <!--begin::Wrapper-->
                <div class="stepper-wrapper">
                  <!--begin::Icon-->
                  <div class="stepper-icon w-40px h-40px">
                    <i class="stepper-check fas fa-check"></i>
                    <span class="stepper-number">4</span>
                  </div>
                  <!--end::Icon-->
  
                  <!--begin::Label-->
                  <div class="stepper-label mx-4">
                    <h3 class="stepper-title">
                      أستكمال عملية الحجز
                    </h3>
                    <div class="stepper-desc fw-semibold">
                      تمت عملية الحجز بنجاح
                    </div>
                  </div>
                  <!--end::Label-->
                </div>
                <!--end::Wrapper-->
              </div>
              <!-- {
                "data": [
                  {
                    "customer": {
                      "name": "asma alhinai",
                      "phone": "94455673",
                      "email": "asma.7neen@gmail.com",
                      "updated_at": "2022-10-21T06:15:12.000000Z",
                      "created_at": "2022-10-21T06:15:12.000000Z",
                      "id": 18
                    },
                    "order": {
                      "code": "6ad5b7a1-7da5-478a-89fe-df4e63a6af4d327819761666332912",
                      "status": 1,
                      "payment_channel": 1,
                      "amount": 12000,
                      "payment_status": 2,
                      "customer_id": 18,
                      "updated_at": "2022-10-21T06:15:12.000000Z",
                      "created_at": "2022-10-21T06:15:12.000000Z",
                      "id": 18
                    },
                    "payment_link": null
                  }
                ]
              } -->
              <div class="my-5 row" dir="rtl">
                <div class="col-md-6 col-sm-12 mb-2" dir="rtl">
                  <div class=" px-4 py-0 sm:px-6" dir="rtl">
                    <div class="stepper-label mx-4  mb-8">
                      <h5 class="stepper-desc fw-semibold text-muted">
                        أسم العميل
                      </h5>
                      <h3 class="stepper-title">
                        {{AllCustomerData.customer['name']}}

                      </h3>
                    </div>
                    <div class="stepper-label mx-4  mb-8">
                      <h5 class="stepper-desc fw-semibold text-muted">
                        رقم الهاتف
                      </h5>
                      <h3 class="stepper-title">
                        {{AllCustomerData.customer['phone']}}
                      </h3>
                    </div>
                    <div class="stepper-label mx-4  mb-8">
                      <h5 class="stepper-desc fw-semibold text-muted">
                        البريد الالكتروني
                      </h5>
                      <h3 class="stepper-title">
                        {{AllCustomerData.customer['email']}}
                      </h3>
                    </div>
                    <div class="stepper-label mx-4  mb-8">
                      <h5 class="stepper-desc fw-semibold text-muted">
المبلغ (بالريال العماني)                      </h5>
                      <h3 class="stepper-title">
                        {{AllCustomerData.order['amount'] / 1000}}
                      </h3>
                    </div>

                  </div>
                </div>
                <div class="col-md-6 col-sm-12 mb-2" dir="rtl">
                  <div class=" px-4 py-0 sm:px-6" dir="rtl">
                    <div class="stepper-label mx-4  mb-8">
                      <h5 class="stepper-desc fw-semibold text-muted">
                        تاريخ الحجز
                      </h5>
                      <h3 class="stepper-title">
                        {{AllCustomerData.order['created_at'] | date}}
                      </h3>
                    </div>
                    <div class="stepper-label mx-4  mb-8">
                      <h5 class="stepper-desc fw-semibold text-muted">
                        طريقة الدفع
                      </h5>
                      <h3 class="stepper-title">
                        <span *ngIf="AllCustomerData.order['payment_channel'] == 1"> عند الوصول </span>
                        <span *ngIf="AllCustomerData.order['payment_channel'] == 2"> أونلاين </span>
                      </h3>
                    </div>

                    <div class="stepper-label mx-4  mb-8" >
                    </div>


                  </div>
                </div>
              </div>
              <div class="my-5 row" dir="rtl">
                <div class="col-md-12 col-sm-12 mb-2" dir="rtl">
              <nz-table [nzFrontPagination]="false"  #basicTable [nzData]="AllCustomerData.order['appointments']">
                <thead>
                  <tr>
                    <th> تاريخ الحجز</th>
                    <th>وقت الحجز</th>
<!--                    <th>الملعب</th>-->

                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of AllCustomerData.order['appointments'] ; let i = index"
                
                  
                  >
                    <td>   {{item['date'] | date}}</td>
                    <td   class=" btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 flex" 
                    style="display: flex;gap: 5px;place-items: center;justify-content: center;direction: ltr;">
                    <span class="fw-bolder fs-3" style="font-size: 14px !important;">  {{   tConvert(item['time']) }}  </span> <br>
                    <span class="fw-bolder fs-3" style="font-size: 14px !important;"> - </span>
                    <span class="fw-bolder fs-3" style="font-size: 14px !important;">  {{  addHours(item['time'])}}  </span>
                    
                    </td>
<!--                    <td>  -->
<!--                      -->
<!--                <span *ngIf="item['court_id'] == 1"> الملعب الأول</span>-->
<!--                <span *ngIf="item['court_id'] == 2">الملعب الثاني</span>-->
<!--                    </td>-->


                  </tr>
                </tbody>
              </nz-table>
            </div>
          </div>
            </ng-container>
          </div>

          <div class="d-flex flex-stack pt-10" dir="rtl">
            <div class="mr-2 flex">
              <ng-container *ngIf="currentStep$.value !== 1 && currentStep$.value !== 5">
                <button type="button" class="btn btn-lg btn-light-primary me-3 flex" (click)="prevStep()">
                  <div class=" flex">
                  <span class="svg-icon svg-icon-4 me-1 flex">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.4 11H3C2.4 11 2 11.4 2 12C2 12.6 2.4 13 3 13H14.4V11Z" fill="currentColor" />
                      <path opacity="0.3" d="M14.4 20V4L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7L14.4 20Z"
                        fill="currentColor" />
                    </svg>

                  </span>
                  <span>للخلف</span>
                </div>
                </button>
              </ng-container>
            </div>

            <ng-container *ngIf="currentStep$.value !== formsCount && currentStep$.value !== 5">
              <div>
                <button type="button" class="btn btn-lg btn-primary me-3" [disabled]="!isCurrentFormValid$.value"
                  (click)="nextStep()">
                  <span class="indicator-label flex">
                    <ng-container *ngIf="currentStep$.value < formsCount - 1" class="flex">


                      <span>متابعة</span>
                      <span dir="rtl" class="svg-icon svg-icon-3 ms-2 me-0">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.60001 11H21C21.6 11 22 11.4 22 12C22 12.6 21.6 13 21 13H9.60001V11Z"
                            fill="currentColor" />
                          <path opacity="0.3" d="M9.6 20V4L2.3 11.3C1.9 11.7 1.9 12.3 2.3 12.7L9.6 20Z"
                            fill="currentColor" />
                        </svg>

                      </span>
                    </ng-container>
                    <ng-container *ngIf="currentStep$.value === formsCount - 1">
                      متابعة
                    </ng-container>
                  </span>
                </button>
              </div>
            </ng-container>


            <ng-container *ngIf="currentStep$.value === 4 ">
              <div *ngIf="currentStep$.value === 4  && formsCount === 4">
                <button type="button" class="btn btn-lg btn-primary me-3"  *ngIf="currentStep$.value === 4  && formsCount === 4"
                  (click)="nextStepConfirm()" [disabled]="isBtnDisabled" [nzLoading]="isBtnDisabled">
                  <span class="indicator-label">
                    <ng-container class="flex">
                      <div class=" flex">
                      <span>{{text_confirm}}</span>
                         <span dir="rtl" class="svg-icon svg-icon-3 ms-2 me-0">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.60001 11H21C21.6 11 22 11.4 22 12C22 12.6 21.6 13 21 13H9.60001V11Z"
                            fill="currentColor" />
                          <path opacity="0.3" d="M9.6 20V4L2.3 11.3C1.9 11.7 1.9 12.3 2.3 12.7L9.6 20Z"
                            fill="currentColor" />
                        </svg>

                      </span>
                    </div>
                    </ng-container>

                  </span>
                </button>



                
              </div>
            </ng-container>

          </div>
        </form>
      </div>
  

    </div>

  </div>
</div>
